// SideBarContext.js
import React, { createContext, useState, useContext } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [openSections, setOpenSections] = useState({
    sidebar: false,
    sections: {},
  });

  const toggleSidebarOpen = () => {
    setOpenSections(prev => ({
      ...prev,
      sidebar: !prev.sidebar
    }));
  };

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      sections: {
        ...prev.sections,
        [sectionId]: !prev.sections[sectionId]
      }
    }));
  };

  return (
    <SidebarContext.Provider 
      value={{ 
        openSections, 
        toggleSidebarOpen, 
        toggleSection 
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};